export default "__VITE_ASSET__DnYp8wjs__"